import * as Redux from 'react-redux'

import * as models from '@owl-nest/models'
import * as shadow from '@owl-nest/shadow'

import * as modalAction from '../../../../actions/modal'
import * as projectModel from '../../../models/project'
import { RootState } from '../../../../reducers'
import { TRACKING_ACTION, TRACKING_SOURCE } from '../utils/trackerEnums'
import * as URLs from '../../../utils/URLs'

type TrackingExtraData = {
  source: TRACKING_SOURCE
}

type UseRewardOptions = {
  optionValuesIds?: string[]
  trackingExtraData?: TrackingExtraData
}

type UseReward = () => {
  handleClick: (id: number, options: UseRewardOptions) => void
}

export const useReward: UseReward = () => {
  const dispatch = Redux.useDispatch()
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)
  const tracking = shadow.useTracking()
  const projectHasEnded = models.project.isFinished<projectModel.ExtraFields>(project)

  function handleClick(id: number, { optionValuesIds, trackingExtraData }: UseRewardOptions): void {
    if (!projectHasEnded) {
      if (!models.project.isOrdersEnabled<projectModel.ExtraFields>(project)) {
        dispatch(modalAction.toggleModalPaymentDisturbance(true))
      } else {
        const reward = (project.rewards ?? []).find(
          (reward) => reward.id === id || (reward.variants ?? []).some((variant) => variant.id === id),
        )
        if (reward) {
          tracking.ecommerce.track('add_to_cart', {
            currency: project.currency,
            value: reward.price,
            items: [
              {
                item_id: String(reward.id),
                item_name: models.reward.title(reward as models.reward.Reward) ?? '',
                item_brand: models.project.name(project),
                item_variant: reward.id === id ? undefined : String(id),
                price: reward.price,
                quantity: 1,
              },
            ],
          })
        }

        if (!models.project.isFinished<projectModel.ExtraFields>(project)) {
          tracking.track({
            event: shadow.EVENT_TYPE.GENERIC,
            eventAction: TRACKING_ACTION.ADD_REWARD,
            eventCallback: () => {
              window.location.href = URLs.getCheckoutURL(project.id, { optionValuesIds, rewardID: id })
            },
            eventCategory: shadow.CATEGORY.PROJECT_PAGE,
            eventLabel: trackingExtraData?.source,
          })
          return
        }
      }
    } else {
      if (project?.post_campaign_link) {
        dispatch(modalAction.toggleModalPostCampaign(true))
      }
    }
  }

  return { handleClick }
}
